import Navbar from "@/components/kenjosset/Navbar"
import Flash from "@/components/kenjosset/Flash"
import Footer from "@/components/kenjosset/Footer"
import PhotoEditor from "@/components/kenjosset/PhotoEditor"
import type { KenjossetChrome } from "@/components/kenjosset/types"

interface Props {
  chrome: KenjossetChrome
  heroSrc: string
}

// Faithful React port of kenjosset/home.html.slim. The outer wrapper and the
// min-height content box reproduce layouts/application (body.bg-light + the
// `min-h-[calc(100vh-500px)] h-full` yield box), which layouts/inertia lacks.
export default function Home({ chrome, heroSrc }: Props) {
  return (
    <div className="bg-light min-h-screen">
      <Navbar chrome={chrome} />

      {/* The hero is the store's `home_photo` attachment, or the committed
          asset as long as none is attached. The editor is inert — it renders
          exactly these children — for everyone but the store's admin. */}
      <PhotoEditor variant="hero" photos={[{ id: null, url: heroSrc, position: 1, alt: "" }]}>
        <div className="min-h-[calc(100vh-500px)] h-full">
          <img
            src={heroSrc}
            alt=""
            className="mx-auto h-screen px-6 sm:px-12 w-full object-cover object-top"
          />
        </div>
      </PhotoEditor>

      <Footer chrome={chrome} />
      <Flash />
    </div>
  )
}
